import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cd5342c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "modal-title",
  role: "dialog",
  "aria-modal": "true"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" }, null, -1))
const _hoisted_3 = { class: "fixed z-10 inset-0 overflow-y-auto" }
const _hoisted_4 = { class: "flex items-end sm:items-center justify-center min-h-full p-4 text-center lg:p-0" }
const _hoisted_5 = { class: "py-4 px-5 md:px-6 border-b flex justify-between items-center flex-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-lg md:text-2xl font-medium text-gray-900" }, "Edit short list", -1))
const _hoisted_7 = { class: "p-5 md:p-6" }
const _hoisted_8 = { class: "w-xs max-w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "name"
}, " Name ", -1))
const _hoisted_10 = { class: "w-xs max-w-full mt-3" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "block text-gray-700 text-sm font-bold mb-2",
  for: "name"
}, " Description ", -1))
const _hoisted_12 = { class: "mt-3" }
const _hoisted_13 = { class: "block text-gray-700 text-sm font-bold mb-2" }
const _hoisted_14 = {
  key: 0,
  class: "border rounded-lg divide-y overflow-scroll",
  style: {"max-height":"220px"}
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "font-normal text-gray-500" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "flex items-center justify-end space-x-3 mt-6" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-sky text-white px-4 py-1.5 rounded-md"
}, " Save ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_XIcon = _resolveComponent("XIcon")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all my-8 max-w-4xl w-full",
          onClick: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("button", {
              type: "button",
              class: "border border-gray-400 bg-white rounded-md text-gray-500 hover:text-gray-800 focus:outline-none p-2 bg-gray-100 ml-4",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal('ModalShortList')))
            }, [
              _createVNode(_component_XIcon, { class: "w-5 h-5" })
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("form", {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleFormSubmit && _ctx.handleFormSubmit(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3", { 'border-red-600': _ctx.showAlerts && !_ctx.collectedData.name }]),
                  id: "name",
                  type: "text",
                  placeholder: "New Short List",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collectedData.name) = $event))
                }, null, 2), [
                  [_vModelText, _ctx.collectedData.name]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _withDirectives(_createElementVNode("textarea", {
                  class: "block appearance-none border border-gray-300 rounded-md shadow-sm text-sm w-full py-2 px-3",
                  id: "name",
                  rows: "2",
                  placeholder: "Short List Description",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.collectedData.description) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.collectedData.description]
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, "Originators (" + _toDisplayString(_ctx.collectedData.originators.length) + ")", 1),
                (_ctx.collectedData.originators.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.collectedData.originators, (originator, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["px-3 py-2 flex justify-between items-center", { 'opacity-50 pointer-events-none': _ctx.originatorsToDelete.includes(originator.id) }])
                        }, [
                          _createElementVNode("p", {
                            class: "text-sm leading-5 font-medium text-sky cursor-pointer",
                            onClick: ($event: any) => (_ctx.showProfile(originator.id))
                          }, [
                            _createTextVNode(_toDisplayString(originator.name) + " ", 1),
                            _createElementVNode("span", _hoisted_16, "(" + _toDisplayString(originator.email) + ")", 1)
                          ], 8, _hoisted_15),
                          _createElementVNode("a", {
                            href: "#remove",
                            onClick: _withModifiers(($event: any) => (_ctx.removeFromList(originator.id)), ["prevent"])
                          }, [
                            _createVNode(_component_TrashIcon, { class: "w-4 h-4 text-red-700" })
                          ], 8, _hoisted_17)
                        ], 2))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("button", {
                  type: "button",
                  class: "bg-gray-100 px-4 py-1.5 rounded-md",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeModal('ModalShortList')))
                }, " Cancel "),
                _hoisted_19
              ])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}